import Helper from "../../Helper";
import { RepeatingCalendarEventDefinition } from "../../models/RepeatingCalendarEventDefinition";
import { plotFetch } from "../Helper/ApiRequest";

export function getRepeatingCalendarEventDefinition(
    teamSubdomain: string,
    projectToken: string,
    repeatingCalendarEventDefinitionId: number,
    timezone: string
): Promise<RepeatingCalendarEventDefinition | null> {
    const url = new URL(
        `${Helper.baseUrlAltSubdomain(teamSubdomain)}/projects/${projectToken}/repeating_calendar_event_definitions/${repeatingCalendarEventDefinitionId}`
    );

    return plotFetch(url.toString(), { method: "GET" })
        .then((response) => {
            if (response.ok) {
                return response.json();
            }
        })
        .then((response) => {
            return RepeatingCalendarEventDefinition.fromApiObject(response, timezone);
        })
        .catch((e) => {
            return null;
        });
}

export function updateRepeatingCalendarEventDefinition(
    teamSubdomain: string,
    projectToken: string,
    repeatingCalendarEventDefinition: RepeatingCalendarEventDefinition,
    timezone: string
): Promise<RepeatingCalendarEventDefinition | null> {
    const url = new URL(
        `${Helper.baseUrlAltSubdomain(teamSubdomain)}/projects/${projectToken}/repeating_calendar_event_definitions/${repeatingCalendarEventDefinition.id}`
    );

    return plotFetch(url.toString(), {
        method: "PUT",
        body: JSON.stringify({ repeating_calendar_event_definition: repeatingCalendarEventDefinition.toApiObject() }),
    })
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            throw new Error("Failed to update");
        })
        .then((response) => {
            return RepeatingCalendarEventDefinition.fromApiObject(response, timezone);
        })
        .catch(() => {
            return null;
        });
}

export function createRepeatingCalendarEventDefinition(
    teamSubdomain: string,
    projectToken: string,
    repeatingCalendarEventDefinition: RepeatingCalendarEventDefinition,
    timezone: string
): Promise<RepeatingCalendarEventDefinition | null> {
    const url = new URL(
        `${Helper.baseUrlAltSubdomain(teamSubdomain)}/projects/${projectToken}/repeating_calendar_event_definitions`
    );

    return plotFetch(url.toString(), {
        method: "POST",
        body: JSON.stringify({ repeating_calendar_event_definition: repeatingCalendarEventDefinition.toApiObject() }),
    })
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            throw new Error("Failed to create calendar event");
        })
        .then((response) => {
            return RepeatingCalendarEventDefinition.fromApiObject(response, timezone);
        })
        .catch(() => {
            return null;
        });
}

export function deleteRepeatingCalendarEventDefinition(
    teamSubdomain: string,
    projectToken: string,
    repeatingCalendarEventDefinition: RepeatingCalendarEventDefinition
): Promise<boolean> {
    const url = new URL(
        `${Helper.baseUrlAltSubdomain(teamSubdomain)}/projects/${projectToken}/repeating_calendar_event_definitions/${repeatingCalendarEventDefinition.id}`
    );

    return plotFetch(url.toString(), { method: "DELETE" }, true)
        .then((data) => {
            if (data.ok) {
                return true;
            }

            throw new Error("Network error.");
        })
        .catch(() => {
            return false;
        });
}
